import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Box, Checkbox, FlexBox, FormDialog, Grid, Icon, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';

interface ReconcilationOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (payload: { fromDate: string | null; toDate: string | null; skipResolve: boolean }) => void;
}

export const ReconcilationOverlay = ({ isOpen, onClose, onApply }: ReconcilationOverlayProps) => {
  const classes = useStyles({ isOpen })();

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [skipResolve, setSkipResolve] = useState(false);

  const handleApply = () => {
    onApply({
      fromDate: startDate ? startDate.toISOString() : null,
      toDate: endDate ? endDate.toISOString() : null,
      skipResolve
    });
    setStartDate(null);
    setEndDate(null);
    onClose();
  };

  const disableApply = !startDate || !endDate;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const DatePickerCustomInput = React.forwardRef((props1: any, ref: any) => {
    return (
      <div
        onClick={props1.onClick}
        ref={ref}
        className={classes.datePickerInput}
        style={{ padding: props1.value ? '0 40px 0 12px' : '0 12px' }}
      >
        <label>{props1.value || props1.placeholder}</label>
        <Icon name="CalendarToday" sx={{ color: '#F46D2E' }} />
      </div>
    );
  });

  return (
    <FormDialog
      open={isOpen}
      title="Payment Reconciliation"
      cancelButtonText="Cancel"
      confirmButtonText="Reconcile"
      cancelButtonAction={onClose}
      confirmButtonAction={handleApply}
      confirmButtonDisabled={disableApply}
    >
      <Grid direction="column" width="100%" marginTop="10px">
        {/* Date range */}
        <FlexBox className={classes.filtersFieldsFlexBox}>
          <Box className={classes.filtersFieldBox}>
            <Typography className={classes.filtersFieldLabel}>Start Date and Time</Typography>
            <div className="my-datepicker-wrapper">
              <div className={classes.datePickerContainer}>
                <DatePicker
                  showTimeSelect
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  placeholderText="MM/DD/YYYY hh:mm aa"
                  dateFormat="MM/dd/yyyy h:mm aa"
                  className={classes.datePickerComponent}
                  isClearable
                  customInput={<DatePickerCustomInput />}
                  calendarClassName="my-custom-calendar"
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </div>
          </Box>

          <Box className={classes.filtersFieldBox}>
            <Typography className={classes.filtersFieldLabel}>End Date and Time</Typography>
            <div className="my-datepicker-wrapper">
              <div className={`${classes.datePickerContainer} ${classes.rightDatePickerContainer}`}>
                <DatePicker
                  showTimeSelect
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  placeholderText="MM/DD/YYYY hh:mm aa"
                  dateFormat="MM/dd/yyyy h:mm aa"
                  className={classes.datePickerComponent}
                  isClearable
                  customInput={<DatePickerCustomInput />}
                  calendarClassName="my-custom-calendar"
                  popperProps={{ strategy: 'fixed' }}
                />
              </div>
            </div>
          </Box>
        </FlexBox>
        {/* Checkbox */}
        <FlexBox alignItems="center" mt={2}>
          <Checkbox
            size="small"
            checked={skipResolve}
            label={<Typography fontWeight={600}>Identify mismatches but do not resolve them.</Typography>}
            onChange={(e) => setSkipResolve(e.target.checked)}
          />
        </FlexBox>
      </Grid>
    </FormDialog>
  );
};
